var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId, injectTestId } from '@cvent/nucleus-test-automation';
import { map } from 'lodash';
import PropTypes from 'prop-types';
const createStyledErrorMessage = (styles, fieldId) => (errorMessage, errorKey) => {
    return React.createElement("div", Object.assign({ key: errorKey }, resolve(styles, 'errorText'), injectTestId('error-message'), { role: "alert", id: `${fieldId}-${errorKey}` }), errorMessage);
};
/**
 * A simple component to display a set of error messages.
 */
const Errors = (_a) => {
    var { errorMessages, fieldId } = _a, rest = __rest(_a, ["errorMessages", "fieldId"]);
    if (Object.keys(errorMessages).length === 0) {
        return null;
    }
    const createErrorMessage = createStyledErrorMessage(rest, fieldId);
    return React.createElement("div", Object.assign({}, resolve(rest, 'container'), resolveTestId(rest)), map(errorMessages, createErrorMessage));
};
Errors.propTypes = {
    errorMessages: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.string), PropTypes.arrayOf(PropTypes.string)]),
    fieldId: PropTypes.string
};
Errors.defaultProps = {
    errorMessages: {},
    fieldId: ''
};
export default Errors;
